import React from "react";
import styles from "./Toggle.module.css";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  isDisabled?: boolean;
  label?: string;
  uniqueKey: string;
}

/**
 * Internal Toggle component for ContentQualityWidget
 */
const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  isDisabled = false,
  label,
  uniqueKey,
}) => {
  const inputId = `${uniqueKey}-toggle-input`;

  return (
    <div className={styles.toggleContainer}>
      <label htmlFor={inputId} className={styles.labelWrapper}>
        <div
          className={`${styles.toggle} ${checked ? styles.checked : ""} ${
            isDisabled
              ? checked
                ? styles.toggleDisabledOn
                : styles.toggleDisabledOff
              : ""
          }`}
        >
          <input
            id={inputId}
            type="checkbox"
            checked={checked}
            onChange={(e) => {
              onChange(e.target.checked);
            }}
            className={styles.input}
            disabled={isDisabled}
          />
          <span
            className={isDisabled ? styles.sliderDisabled : styles.slider}
          />
        </div>
        {label && (
          <span className={styles.labelText}>
            <span className={isDisabled ? styles.toggleDisabledLabel : ""}>
              {label}
            </span>
          </span>
        )}
      </label>
    </div>
  );
};

export default Toggle;
